import PropTypes from 'prop-types';
import React from 'react';
import FeedbackBodyShimmer from './feedback-body-shimmer';

// Keeps the current screen (and its answers) mounted while another language
// loads, covered by the body shimmer.
const FeedbackSwitchingOverlay = ({ active, children }) => (
  <div className="relative">
    {children}
    {active && (
      <div className="absolute inset-0 bg-white">
        <FeedbackBodyShimmer />
      </div>
    )}
  </div>
);

FeedbackSwitchingOverlay.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

FeedbackSwitchingOverlay.defaultProps = {
  active: false,
};

export default FeedbackSwitchingOverlay;
